import { jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, Badge } from "braid-design-system";
import { translations } from "../../../../components/.vocab/index.mjs";
import { badge } from "./NeedsUpdateBadge.css.mjs";
const NeedsUpdateBadge = () => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsx(Box, { className: badge, children: /* @__PURE__ */ jsx(
    Badge,
    {
      weight: "strong",
      tone: "caution",
      children: t("Needs update")
    },
    "bx-brand-card-badge-need-update"
  ) });
};
export {
  NeedsUpdateBadge
};
